import { getArticleDetails, getPreviousNextArticle, updateViewCount } from "../../api/article";
import { reactive, nextTick, ref } from "vue";
import markdownIt from "../../utils/markdown-it";
import { mapState } from "../../store/map";
import { useDefaultThumbnail, defaultThumbnail } from "../../utils/thumbnail";
import buildCodeBlock from "../../utils/code-block";
import { renderByMathjax, initMathJax } from "../../utils/mathjax";
import router from "../../router";
export default {
  name: "ArticleDetails",
  setup: function setup(props) {
    window.scrollTo({
      top: 0
    });

    var _mapState = mapState("adminAbout"),
        adminInfo = _mapState.adminInfo,
        isAdmin = _mapState.isAdmin;

    var articleLoaded = ref(false);
    var articleUrl = ref(window.location.href);
    var previousArticle = reactive({});
    var nextArticle = reactive({});
    var lightBoxRef = ref(); // 获取文章内容

    var articleDetails = reactive({
      createTime: ""
    });
    getArticleDetails(props.id).then(function (data) {
      Object.assign(articleDetails, data);
      articleDetails.content = markdownIt.render(data.content);
      nextTick(function () {
        initMathJax({}, function () {
          renderByMathjax(".article-content");
        });
        buildCodeBlock(".article-content");
        articleLoaded.value = true;
      }).then(function () {
        lightBoxRef.value.addImageClickedListener();
      });
    });
    updateViewCount(props.id); // 获取上一篇和下一篇文章

    getPreviousNextArticle(props.id).then(function (data) {
      if (data.previous) {
        Object.assign(previousArticle, data.previous);

        if (!previousArticle.thumbnail) {
          previousArticle.thumbnail = defaultThumbnail;
        }
      }

      if (data.next) {
        Object.assign(nextArticle, data.next);

        if (!nextArticle.thumbnail) {
          nextArticle.thumbnail = defaultThumbnail;
        }
      }
    });

    function editArticle() {
      router.push("/article/".concat(props.id, "/edit"));
    }

    return {
      isAdmin: isAdmin,
      articleDetails: articleDetails,
      articleLoaded: articleLoaded,
      adminInfo: adminInfo,
      articleUrl: articleUrl,
      useDefaultThumbnail: useDefaultThumbnail,
      previousArticle: previousArticle,
      nextArticle: nextArticle,
      lightBoxRef: lightBoxRef,
      editArticle: editArticle
    };
  },
  props: ["id"]
};